import PageStyle from './enumerations/PageStyle.json';

export function componentForStyle(styleId) {
	switch (styleId) {
		case PageStyle.TriplePlayLottery:
			return () =>
				import('@homepage/components/streams/TripleplayLotteryStream.vue');
		case PageStyle.ArgentinaLottery:
			return () =>
				import('@homepage/components/streams/ArgentinaLotteryStream.vue');
		case PageStyle.EasyMoney:
			return () => import('@homepage/components/streams/EasyMoneyStream.vue');
		case PageStyle.QuickLotto:
			return () => import('@homepage/components/streams/QuickLottoStream.vue');
		case PageStyle.FantastikLottery:
			return () =>
				import('@homepage/components/streams/FantastikLotteryStream.vue');
		case PageStyle.LeslycVip:
			return () => import('@homepage/components/streams/LeslycVipStream.vue');
		default:
			return null;
	}
}

export function getStyleName(styleId) {
	switch (styleId) {
		case PageStyle.LuckyLotto:
			return 'luckyLotto';
		case PageStyle.SuperLotto:
			return 'superLotto';
		case PageStyle.SiprizLotto:
			return 'siprizLotto';
		case PageStyle.QuickCash:
			return 'quickCash';
		case PageStyle.FastPlay:
			return 'fastPlay';
		case PageStyle.LottoHotpicks:
			return 'hotpicksLotto';
		case PageStyle.FastPay:
			return 'fastPay';
		case PageStyle.QuickMoney:
			return 'quickMoney';
		case PageStyle.FastPayTv:
			return 'fastPayTv';
		case PageStyle.PowerPlay:
			return 'powerPlay';
		case PageStyle.EasyMoney:
			return 'easyMoney';
		case PageStyle.CaribbeanLotto:
			return 'caribbeanLotto';
		case PageStyle.NoLimitLotto:
			return 'noLimitLotto';
		case PageStyle.WorldLottery:
			return 'worldLottery';
		case PageStyle.QuickLotto:
			return 'quicklotto';
		case PageStyle.PremierLotto:
			return 'premierlotto';
		case PageStyle.CaribbeanPick:
			return 'caribbeanPick';
		case PageStyle.ParadiseLottery:
			return 'paradiseLottery';
		case PageStyle.TriplePlayLottery:
			return 'paradiseLottery';
		default:
			throw new Error(`Page style ${styleId} not found.`);
	}
}
